import React, { useRef } from "react";
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
import "./user-profile-dropdown.css";
import { Link } from "react-router-dom";
import userImg from "../../../assets/img/profile.svg";
import routes from "../../../Views/Pages/routes/routesConfig/index";
import translation from "../../../utils/translation";
import { useHrmsPermissions } from "../../../utils/permissions/hrmsPermissionsUtils";

const UserProfileDropdown = ({ logOut }) => {
  const dropdownToggleRef = useRef(null);
  const { permissionList } = useSelector((state) => state.users);
  const settingsPermission = useHrmsPermissions(permissionList);
  const {
    canViewMyProfile,
    canViewMyCalendar,
    canAddLeave,
    canRaiseTimeRequest,
  } = settingsPermission;
  return (
    <Dropdown className="nav-item user-profile-dropdown" ref={dropdownToggleRef}>
      <Dropdown.Toggle as="span" className="nav-link drop-toggle p-0">
        <Link
          className="nav-link userProfileLink p-0"
          onClick={(e) => e.preventDefault()}
        >
          <img src={userImg} className="user-image" alt="UserImage" />
        </Link>
      </Dropdown.Toggle>
      <Dropdown.Menu className="border-0 p-0" style={{ minWidth: '300px' }}>
        <ul className="profile-menu-list bg-white">
          {canViewMyProfile && (
            <li className="m-0">
              <Link className="black" to={routes.myProfile}>
                {translation('key_my_profile')}
              </Link>
            </li>
          )}
          {canAddLeave && <li className="m-0">
            <Link className="black" to={routes.leaves}>
              {translation('key_apply_leave')}
            </Link>
          </li>}
          {canViewMyCalendar && <li className="m-0">
            <Link className="black" to={routes.myCalendar}>
              {translation('key_my_calendar')}
            </Link>
          </li>}
          {canRaiseTimeRequest && <li className="m-0">
            <Link className="black" to={routes.timeRequests}>
              {translation('key_raise_time_request')}
            </Link>
          </li>}

          <li className="m-0">
            <Link className="black" onClick={logOut}>
              {translation('key_log_out')}
            </Link>
          </li>
          <li className="m-0">
            <Link className="black" to={routes.myReportees}>
              {translation('key_my_reportees')}
            </Link>
          </li>
        </ul>
      </Dropdown.Menu>
    </Dropdown>
  );
};
UserProfileDropdown.propTypes = {
  logOut: PropTypes.func.isRequired,
};
export default UserProfileDropdown;
